import _ from 'lodash';
import useSWR from 'swr';
import { getBoardItem } from '@gorilla/common/src/lib/monday-api/api';
import { mondayClient } from '../../services/monday';

export function useItem(itemId?: number) {
  const {
    data: item,
    error,
    isLoading,
  } = useSWR(
    itemId ? `/item/${itemId}` : null,
    async () => {
      if (!itemId) {
        return null;
      }

      return await getBoardItem(mondayClient, itemId!);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  return {
    item,
    error,
    isLoading,
  };
}
